import React from 'react';
import PropTypes from 'prop-types';
import { BIZ_SVG_LG, FN_SVG_LG, KPI_SVG_LG } from '../utils/icons';

class KpiDashboardCards extends React.Component {
    render() {
        const { counts } = this.props;

        const cardsData = [
            { tag: 'BIZ', icon: BIZ_SVG_LG, color: '#4338caff', label: 'Business', desc: 'A top-level division of the organisation — e.g. Commercial or Supply Chain.', key: 'biz' },
            { tag: 'FN', icon: FN_SVG_LG, color: '#1D6FA4', label: 'Function', desc: 'A capability area inside a business that groups its related KPIs and models.', key: 'fn' },
            { tag: 'KPI', icon: KPI_SVG_LG, color: '#15803D', label: 'KPI', desc: 'A single measurable metric, with a plain-text formula for how its calculated.', key: 'kpi' }
        ];

        return (
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-3 tw-pt-1 tw-bg-slate-50/50 dark:tw-bg-transparent">
                {cardsData.map(card => {
                    const [act, tot] = counts[card.key] || [0, 0];
                    return (
                        <div key={card.tag} className="tw-relative tw-text-left tw-border tw-border-solid tw-border-[#E5E5E5] dark:tw-border-white/10 tw-bg-white dark:tw-bg-[#2B2B40] tw-rounded-xl tw-p-3 tw-pl-4 tw-shadow-sm hover:tw-border-slate-300 dark:hover:tw-border-white/20 hover:tw-bg-slate-50/50 dark:hover:tw-bg-[#3A3A55]">
                            <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
                                <div className="tw-flex tw-items-center tw-gap-2.5 tw-min-w-0">
                                    <div className="tw-w-7 tw-h-7 tw-rounded-lg tw-border tw-border-solid tw-border-[#E2E8F0] dark:tw-border-white/10 tw-bg-[#F8FAFC] dark:tw-bg-white/5 tw-inline-flex tw-items-center tw-justify-center tw-shrink-0 tw-text-[#475569] dark:tw-text-white">
                                        {card.icon}
                                    </div>
                                    <span className="tw-text-sm tw-font-semibold tw-text-[#181D27] dark:tw-text-white">{card.label}</span>
                                </div>
                                <div className="tw-flex tw-items-baseline tw-gap-0.5 tw-leading-none tw-shrink-0" title={`${act} active of ${tot}`}>
                                    <strong className="tw-text-2xl tw-font-semibold tw-tracking-tight tw-text-[#181D27] dark:tw-text-white">{act}</strong>
                                    <span className="tw-text-xs tw-text-[#535862] dark:tw-text-[#B2B5BE]">/ {tot}</span>
                                </div>
                            </div>
                            <p className="tw-text-xs tw-text-[#535862] dark:tw-text-[#B2B5BE] !tw-mt-2 tw-mb-0 tw-line-clamp-2">{card.desc}</p>
                        </div>
                    );
                })}
            </div>
        );
    }
}

KpiDashboardCards.propTypes = {
    counts: PropTypes.object.isRequired,
};

export default KpiDashboardCards;
